import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const UpdateMyPasswordRequestDtoSchema = z.object({
  newPassword: z.string(),
  oldPassword: z.string(),
});

const UpdateMyPasswordResponseDtoSchema = z.string();

export type UpdateMyPasswordRequestDto = z.infer<
  typeof UpdateMyPasswordRequestDtoSchema
>;
export type UpdateMyPasswordResponseDto = z.infer<
  typeof UpdateMyPasswordResponseDtoSchema
>;

export const updateMyPassword = (
  dto: UpdateMyPasswordRequestDto,
  config?: AxiosRequestConfig<UpdateMyPasswordRequestDto>
) => {
  const data = UpdateMyPasswordRequestDtoSchema.parse(dto);
  return api
    .post('/users/me/update-password', data, config)
    .then(responseContract(UpdateMyPasswordResponseDtoSchema));
};
